import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23d05e6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "ClientUsersModal",
  tabindex: "-1",
  "data-bs-backdrop": "true",
  "aria-labelledby": "ClientUsersModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "nav nav-pills",
  id: "pills-tab",
  role: "tablist"
}
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  ref: "closeBtn"
}
const _hoisted_11 = { class: "modal-body" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = { class: "tab-content ps-1" }
const _hoisted_14 = {
  key: 0,
  class: "",
  id: "pills-home"
}
const _hoisted_15 = {
  key: 1,
  class: "",
  id: "pills-home"
}
const _hoisted_16 = { class: "table" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Name")
    ]),
    /*#__PURE__*/_createElementVNode("th", { scope: "col text-end" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Placeholder")
    ])
  ])
], -1))
const _hoisted_18 = { scope: "row" }
const _hoisted_19 = {
  key: 0,
  class: "create-external-user"
}
const _hoisted_20 = {
  key: 2,
  class: "",
  "aria-labelledby": "pills-profile-tab"
}
const _hoisted_21 = { class: "table" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Name")
    ]),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Used in no. of tasks")
    ]),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Users")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-end"
    }, [
      /*#__PURE__*/_createElementVNode("b", null, "Actions")
    ])
  ])
], -1))
const _hoisted_23 = {
  scope: "row",
  class: ""
}
const _hoisted_24 = { class: "" }
const _hoisted_25 = {
  key: 0,
  class: "btn btn-info btn-sm cursor-pointer"
}
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "text-end" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "create-external-user"
}
const _hoisted_30 = {
  key: 3,
  class: ""
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GlobalVariablesSection = _resolveComponent("GlobalVariablesSection")!
  const _component_CreateExternalUser = _resolveComponent("CreateExternalUser")!
  const _component_user_selection = _resolveComponent("user-selection")!
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_CreatePlaceholder = _resolveComponent("CreatePlaceholder")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link cursor-pointer h6", { active: _ctx.step == 'users' }]),
                id: "pills-home-tab",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.step = 'users'), ["stop"])),
                "aria-selected": "true"
              }, "Client Users", 2)
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link cursor-pointer h6", { active: _ctx.step == 'placeholders' }]),
                id: "pills-profile-tab",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.step = 'placeholders'), ["stop"])),
                "aria-selected": "false"
              }, "Placeholders", 2)
            ]),
            _createElementVNode("li", _hoisted_8, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link cursor-pointer h6", { active: _ctx.step == 'variables' }]),
                id: "pills-home-tab",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.step = 'variables'), ["stop"])),
                "aria-selected": "true"
              }, "Variables", 2)
            ]),
            _createElementVNode("li", _hoisted_9, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link cursor-pointer h6", { active: _ctx.step == 'share' }]),
                id: "pills-contact-tab",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.step = 'share'), ["stop"])),
                "aria-selected": "false"
              }, "Share", 2)
            ])
          ]),
          _createElementVNode("button", _hoisted_10, null, 512)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              (_ctx.step == 'variables')
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_GlobalVariablesSection)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.step == 'users')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("table", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.externalUser, (user) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: user.userId
                          }, [
                            _createElementVNode("th", _hoisted_18, _toDisplayString(user.data.firstName) + " " + _toDisplayString(user.data.lastName), 1),
                            _createElementVNode("td", null, [
                              (_ctx.hasPlaceholders(user.userId))
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "has-placeholder",
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.step = 'placeholders'))
                                  }, _toDisplayString(_ctx.hasPlaceholders(user.userId)), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    (_ctx.createExternalUser)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createVNode(_component_CreateExternalUser, {
                            id: 12,
                            onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.createExternalUser = false)),
                            onAddUser: _cache[6] || (_cache[6] = ($event: any) => (_ctx.createExternalUser = false)),
                            inviteToProcess: _ctx.process
                          }, null, 8, ["inviteToProcess"])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isTemplateBuilder)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "btn btn-primary btn-sm float-end cursor-pointer",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.createExternalUser = true))
                        }, "Invite User"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.step == 'placeholders')
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("table", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.placeholders, (placeholder) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: placeholder.placeholderId
                          }, [
                            _createElementVNode("th", _hoisted_23, _toDisplayString(placeholder.name), 1),
                            _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.unresolvedPlaceholders(placeholder.placeholderId).length ?
                  _ctx.unresolvedPlaceholders(placeholder.placeholderId).length : ''), 1),
                            _createElementVNode("td", null, [
                              (_ctx.hasUsers(placeholder.placeholderId))
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "has-placeholder inline-block",
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.step = 'placeholders'))
                                  }, _toDisplayString(_ctx.hasUsers(placeholder.placeholderId)), 1))
                                : _createCommentVNode("", true),
                              (!_ctx.isTemplateBuilder && !_ctx.hasUsers(placeholder.placeholderId) && _ctx.unresolvedPlaceholders(placeholder.placeholderId).length)
                                ? (_openBlock(), _createBlock(_component_user_selection, {
                                    key: 1,
                                    selectedUsers: [],
                                    "onUpdate:selectedUsers": _ctx.resolve,
                                    onClick: ($event: any) => (_ctx.selectedPlaceholder = placeholder.placeholderId),
                                    label: "Exchange User",
                                    exactlyOne: true,
                                    hidePlaceholder: true
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.replacingUser != placeholder.placeholderId)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, " Assign User "))
                                        : _createCommentVNode("", true),
                                      (_ctx.replacingUser == placeholder.placeholderId)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            class: "btn btn-primary btn-sm cursor-pointer",
                                            disabled: _ctx.replacingUser
                                          }, " Assigning ... ", 8, _hoisted_26))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["onUpdate:selectedUsers", "onClick"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_27, [
                              (!_ctx.hasUsers(placeholder.placeholderId) && !_ctx.unresolvedPlaceholders(placeholder.placeholderId).length)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "inline-block",
                                    onClick: ($event: any) => (_ctx.deletePlaceholder(placeholder.placeholderId))
                                  }, [
                                    _createVNode(_component_feather_icon, {
                                      type: "trash",
                                      class: "btn btn-outline-danger btn-sm",
                                      size: "16"
                                    })
                                  ], 8, _hoisted_28))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    (_ctx.addPlaceholder)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createVNode(_component_CreatePlaceholder, {
                            id: 12,
                            onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addPlaceholder = false)),
                            onAddPlaceholder: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addPlaceholder = false))
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: "btn btn-primary btn-sm float-end cursor-pointer",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addPlaceholder = true))
                    }, "Add Placeholder")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.step == 'share')
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createTextVNode(" Share Content....."),
                    _hoisted_31,
                    _createTextVNode(" Coming Soon ")
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}